import { store }                from 'index';
import { SET_COMPONENTS_STATE } from 'actions';
import { objType }              from 'types';

const handleSubmit = (question: number, variant: string, lastTest: boolean) => { 

    const state              = store.getState();
    const componentsState    = state.components;
    const { tens, units }    = componentsState;
    const setComponentsState = (payload: objType) => store.dispatch(SET_COMPONENTS_STATE(payload))

    const succeede = () => {
        setComponentsState({
            ...componentsState,
            success:          true,
            hideFeedBack:     false,
            showPyrotechnics: lastTest,
        })
    }

    const failDnd = () => {
        setComponentsState({
            ...componentsState,
            failurCount:  componentsState.failurCount + 1,
            hideFeedBack: false,
            tens: {
                ...tens,
                value: componentsState.failurCount === 2 ? -1 : tens.value
            },
            units: {
                ...units,
                value: componentsState.failurCount === 2 ? -1 : units.value
            }
        })
    }

    const failInput = () => {
        setComponentsState({
            ...componentsState,
            hideFeedBack:   false,
            failurCount:    componentsState.failurCount + 1,
            updateFailType: true
        })
    }

    if (variant === 'dnd') {

        const tensVal = question < 10 ? 0 : tens.value * 10;
        const unitsVal = Math.max(units.value, 0)

        if (tensVal + unitsVal === question ) {
            succeede();
        }
        else {
            failDnd()
        }
    }
    else {
        if (componentsState.textInput === `${ question }`) {
            succeede();
        }
        else {
            failInput()
        }
    }
    

}

export default handleSubmit;
